import React from 'react';
import { PageSection } from 'adc-ui-components';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import OrderListItem from '../../components/OrderListItem';
import { SWAPS_NEW, withQuery } from '../../helpers/routes';
import { getDeviceFromAccount } from '../../helpers/account';
import { getEligibleDevices } from '../../helpers/swaps';

const SwapOrders = ({
  accountData,
  orderData,
  isEligible,
}) => (
  <PageSection>
    <div className="hgroup">
      <div className="hgroup--inline">
        <div>
          <h1>Your Orders</h1>
          <p>Start a new device update or review your recent activity.</p>
        </div>
        {isEligible && (
          <div>
            <Link to={withQuery(SWAPS_NEW)} className="button mb0">Update Devices</Link>
          </div>
        )}
      </div>
    </div>
    {
      orderData.map(order => (
        <OrderListItem
          order={order}
          accountData={accountData}
          key={order.orderId}
          action={(
            <Link className="link" to={withQuery(`/equipment-update/${order.orderId}`)}>
              Manage Order
            </Link>
          )}
        />
      ))
    }
  </PageSection>
);

const mapStateToProps = (state) => {
  const {
    account: { data: accountData },
    swaps: { data: { orders: orderData = [] } = {} },
    swapEligibility: {
      data: { devices = [] } = {},
    },
  } = state;

  const accountDevices = getDeviceFromAccount(accountData);
  const eligibleDevices = getEligibleDevices({ devices }, accountDevices);
  const isEligible = eligibleDevices.length > 0;

  return {
    accountData,
    orderData,
    isEligible,
  };
};

export default connect(mapStateToProps)(SwapOrders);
